import React, { Component } from "react";
import { observer } from "mobx-react";

import Modal from "@/components/modal/index";
import Hero from "./hero";
import Summary from "./summary";
import Store from "@/stores";

@observer
class Result extends Component {
	state = { isSync: false, toggle: false }
	render() {
		const { battleTag } = Store._ladderStore.target;
		const { isSync, toggle } = this.state;
		return (
			<div className="ladder-result">
				<h3>选择<span>{battleTag}</span>下的英雄</h3>
				<h4>
					英雄列表根据最后登录时间排序显示，如有英雄为显示，请点击：
					<a className={isSync ? "disabled" : ""} onClick={this.sync.bind(this)}>同步英雄列表</a>
				</h4>
				<div className="clearfix">
					<Hero />
					<Summary />
				</div>
				<Modal className="ladder-result-modal" toggle={toggle} close={this.closeModal.bind(this)}>
					<h3>同步英雄列表</h3>
					<p>正在同步中，请稍后再来查看</p>
					<button type="button" onClick={this.closeModal.bind(this)}>知道了</button>
				</Modal>
			</div>
		);
	}
	async sync() {
		const { syncData } = Store;
		await syncData();
		this.setState({
			isSync: true,
			toggle: true
		});
	}
	closeModal() {
		this.setState({ toggle: false });
	}
}
export default Result;